module.exports = __webpack_public_path__ + "img/resize-icon-mt.4cac14b6.svg";